import React from "react";
import { makeStyles } from "@material-ui/core/styles";

import { T, PICKUP_WORKFLOW } from "../constants";
import { cx } from "../ui";

const useStyles = makeStyles({
  list: {
    display: "grid",
    gridTemplateColumns: `repeat(${PICKUP_WORKFLOW.length}, minmax(0, 1fr))`,
    gap: 4,
    margin: "8px 0 4px",
    padding: 0,
    listStyle: "none",
  },
  step: { display: "flex", flexDirection: "column", gap: 6, minWidth: 0 },
  bar: { height: 4, borderRadius: 999, background: T.muted },
  done: { background: T.primary, opacity: 0.45 },
  current: { background: T.primary },
  label: { fontSize: 10, color: T.subtleFg, lineHeight: 1.2 },
  labelCurrent: { color: T.primary, fontWeight: 600 },
});

/* How far along the guest's pickup is, at a glance. */
export default function PickupProgress({ status }) {
  const s = useStyles();
  const index = PICKUP_WORKFLOW.findIndex((step) =>
    step.statuses.includes(status),
  );

  return (
    <ol className={s.list} aria-label="Pickup progress">
      {PICKUP_WORKFLOW.map((step, position) => (
        <li
          key={step.key}
          className={s.step}
          aria-current={position === index ? "step" : undefined}
        >
          <span
            className={cx(
              s.bar,
              position < index && s.done,
              position === index && s.current,
            )}
          />
          <span
            className={cx(s.label, position === index && s.labelCurrent)}
          >
            {step.label}
          </span>
        </li>
      ))}
    </ol>
  );
}
